import { postFetch } from '../fetch';
import { apiConfig } from '../config';

interface TeamCode {
    code: string
}

export function postGenerateCode(teamId: number): Promise<TeamCode> {
    const { apiPostGenerateCode } = apiConfig.getStaticUrls();

    return postFetch(apiPostGenerateCode, { teamId });
}
